<h2 mat-dialog-title>Additional Notes (Optional)</h2>

<mat-dialog-content>
  <mat-form-field class="full-width" >
    <mat-label>Type your message here</mat-label>
    <textarea matInput [(ngModel)]="additionalNote" rows="3"></textarea>
  </mat-form-field>

  <p style="margin:16px 0 4px 0;">Please add a payment receipt.</p>

  <app-multi-files
    [idfather]="paymentID"
    [type]="notesType"
    >
  </app-multi-files>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button 
    (click)="onPrevious()"
    class="gts-btn-primary-outline"
    style="font-size:smaller; margin-right: 7px; "
    matRipple>      
       <span class="gts-btn-icon-left">  arrow_back</span>
        <span class="gts-btn-text"> Previous </span>
     </button>
    
     <button   class="gts-btn-primary-outline" matRipple  (click)="onSubmit()"  style="font-size:smaller;" [disabled]="submitting">
        <span class="gts-btn-text" *ngIf="!submitting">Submit</span>

        <i
          class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
          *ngIf="submitting"
        ></i>
      </button>

</mat-dialog-actions>
